import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { PreviousSubmissionsTableComponent } from "./previous-submissions-table.component";

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [PreviousSubmissionsTableComponent],
  exports: [PreviousSubmissionsTableComponent],
})
export class PreviousSubmissionsTableModule {}
